export const isMachineCodingEnabledFor = (enabledFeatures?: string[]): boolean => (
  Boolean(enabledFeatures?.includes('machine-coding'))
);
